import FileUploader from './file-uploader';
import LinkUploader from './link-uploader';
import Modal from 'libs/components/modal';

export default {
  props: ['coursework'],

  template: '#submission_step_template',

  data() {
    return {
      number: 0,
      isInView: false,
      coursework_entry: null,
      $proctorModal: null
    };
  },

  components: {
    'file-uploader': FileUploader,
    'link-uploader': LinkUploader
  },

  computed: {
    isSubmitted() {
      return this.coursework.is_submitted || this.coursework.group.submitted
    },

    isGraded() {
      return this.coursework.is_graded || this.coursework.group.graded
    },

    isResubmittable() {
      return this.coursework.is_resubmittable || this.coursework.group.resubmittable
    },

    isGradeViewable() {
      return this.coursework.is_grade_viewable || this.coursework.group.grade_viewable
    },

    type() {
      if (this.coursework.type === 'Survey') {
        return 'Survey'
      } else if (this.coursework.is_form_builder_type) {
        return 'Form'
      } else {
        return 'Assignment'
      }
    },

    name() {
      if (this.isSubmitted) {
        return `${this.type} ${this.submissionVerb(true)}`;
      } else {
        return `${this.submissionVerb(false)}`;
      }
    },

    task() {
      return `${this.submissionVerb(false)}`;
    },

    isVisible() {
      return this.coursework.is_submittable_type;
    },

    isActive() {
      return this.isVisible && (
        !this.coursework.is_group || (
          this.coursework.group.joined &&
            this.coursework.group.isActive
          )
        )
    },

    isComplete() {
      return this.isSubmitted
    },

    submittedMessage() {
      let group = this.coursework.group.enabled;
      let submitted = this.coursework.is_submitted;
      let group_submitted = this.coursework.group.submitted;
      let group_submitter = this.coursework.group.self_submitted;
      let group_submitter_name = this.coursework.group.submitter.full_name;
      let message = '';

      if (group && group_submitted)
        if (group_submitter)
          message = 'You have submitted the coursework for your group';
        else
          message = group_submitter_name + ' has submitted the coursework for your group. If you resubmit you will override the current submission.';
      else if (submitted)
        message = `You have submitted the ${this.type.toLowerCase()}.`;

      return message;
    },
    resubmissionPolicyMessage() {
      let message = '';

      if (this.coursework.is_resubmittable_type)
        message += `It can be resubmitted ${ Kadenze.isKadenze ? 'within 24 hours of the submission.' : 'until it is graded or the due date, whichever comes first.' }`;

      return message;
    },
    submissionWindowStatus() {
      let status = 'current';
      if (!this.coursework.is_submittable) {
        if (this.coursework.start_date && moment().isBefore(this.coursework.start_date)) {
          status = 'future';
        } else if (this.coursework.end_date && moment().isAfter(this.coursework.end_date)) {
          status = 'past';
        }
      }
      return status;
    },
    submissionWindowTitle() {
      let status = this.submissionWindowStatus;
      let title = '';
      if (status === 'future') {
        title = 'Submission window has not opened yet';
      } else if (status === 'past') {
        title = 'Submission window has closed';
      }
      return title;
    },
    submissionWindowMessage() {
      let status = this.submissionWindowStatus;
      let verb = (status === 'future') ? 'will be' : 'was';
      let message = `Submission ${verb} open`;
      let start_date, end_date;
      if (this.coursework.start_date) {
        start_date = this.$options.filters.dateDisplay(this.coursework.start_date);
        message += ` from <strong>${start_date}</strong>`;
      }
      if (this.coursework.end_date) {
        end_date = this.$options.filters.dateDisplay(this.coursework.end_date);
      } else {
        end_date = 'course ends';
      }
      message += ` until <strong>${end_date}</strong>`;
      return message;
    },

    submittedBtnVisible() {
      return !(this.isSubmitted && this.coursework.type === 'Survey')
    },

    submitBtnText() {
      let text = `${this.submissionVerb(false)}`;

      if (this.isSubmitted || this.isGraded)  {
        if (!this.isResubmittable) {
          text = 'View Grade';
        } else {
          text = 'View / Resubmit';
        }
      }

      return text;
    },

    disabledSubmitBtnText() {
      if (!this.coursework.is_submittable) {
        return (this.submissionWindowStatus == 'future') ? 'Submission Not Open' : 'Submission Closed';
      }
    },
    submittedFieldEntries() {
      return this.coursework.group.enabled ? this.coursework.group.coursework_field_entries : this.coursework.coursework_field_entries;
    }
  },
  methods: {
    submissionVerb(past) {
      if (past)
        return 'Submitted';
      else
        return this.coursework.submittable_text
    },

    getCourseworkEntry() {
      const request = new Kadenze.AjaxRequest({
        type: 'GET',
        url: Kadenze.Routes.course_coursework_coursework_entry_info_path(this.coursework.course_id, this.coursework.id)
      });

      request.done((data, _textStatus, _xhr) => {
        this.coursework_entry = data;
      });

      request.fail((xhr, _responseText, _textStatus) => {
        new Kadenze.Notice.error(xhr.responseJSON);
      });

      return request;
    },

    initProctorModal() {
      this.$proctorModal = $('#proctor-modal');

      this.$proctorModal.off('hide.bs.modal').on('hide.bs.modal', e => {
        const VM = this.$proctorModal.data().VM;

        const done = () => {
          try {
            VM.closeConfirmed(true);
            VM.close();
          } catch (e) {
            console.log(e);
          }

          this.closeUploader();
        };

        if (!VM.closeConfirmed()) {
          if (!VM.isPlatformSupported() || (VM.isLastStep() && !VM.beenProctored())) {
            done();
          } else {
            Kadenze.UIUtil.confirmAction(null, null, done, {
              title: 'Are you sure you want to exit this verification session?',
              body: 'You will not be able to submit your assignment until you have verified your identity. Click Complete Verification to continue with the process, or click Exit Verification to complete verification at another time.',
              ok_btn_text: 'Complete Verification',
              cancel_btn_text: 'Exit Verification'
            });
          }

          return false;
        }
      });
    },

    showProctorModal(redirect) {
      if (this.coursework.requires_proctoring) {
        this.$proctorModal.modal('show');

        const ProctorVM = this.$proctorModal.data().VM;

        ProctorVM.courseworkId(this.coursework.id);
        ProctorVM.initialTraining(this.coursework.never_proctored);
        ProctorVM.closeRedirect(redirect);
        ProctorVM.initUI();
      } else if (redirect) {
        window.location.href = redirect;
      }
    },

    openExternalApplication() {
      const url = Kadenze.Routes.lti_frame_course_coursework_path(
        this.coursework.course_id,
        this.coursework.id
      );

      window.open(url, '_blank');
    },

    showUploader(event) {
      const button = Ladda.create(event.target);

      if (button)
        button.start();

      this.getCourseworkEntry(true).done(() => {
        this.coursework.is_submitting = true;
        this.showProctorModal();
      });
    },

    closeUploader() {
      this.coursework.is_submitting = false;
    },

    showSubmittedNotice() {
      Modal.for('confirmation-w-icon', {
        title: I18n.t('conversation.coursework_submission.confirm_title'),
        body: I18n.t('conversation.coursework_submission.confirm_body'),
        hideCancel: true,
        okBtnText: I18n.t('conversation.coursework_submission.confirm_ok_button'),
        modalSize: 'sm',
        iconClass: 'kf-icon kf-timer'
      })
    },

    submitCoursework(event) {
      if ((this.isSubmitted || this.isGraded) && !this.isResubmittable) {
        if (this.isGraded && this.isGradeViewable) {
          Kadenze.Request.pjax({
            url: Kadenze.Routes.course_coursework_grades_view_path(
              this.coursework.course_id,
              this.coursework.id
            ),
            container: $('#main-pjax-container')
          });
        } else {
          this.showSubmittedNotice();
        }
      } else {
        Kadenze.Analytics.track(
          'coursework',
          'begin_submission',
          { coursework: this.coursework.tracking_data }
        );

        if ((Kadenze.UIUtil.isMobileOrTablet() || Kadenze.UIUtil.isMobileApp()) && Kadenze.isKadenze) {
          $('#mobile-coursework-submission-blocked-modal').modal('show');
          return;
        }

        const type = this.coursework.type;

        if (type === 'FormSubmission' || type === 'Survey') {
          const preview = Kadenze.Util.getParameterByName('preview');

          const previewExitPath = Kadenze.Util.getParameterByName('exit_path');

          const url = Kadenze.Routes.course_coursework_submit_path(
            this.coursework.course_id,
            this.coursework.id,
            preview ? { preview: true, exit_path: previewExitPath } : null
          )

          this.showProctorModal(url);

        } else if (type === 'LinkAssignment' || type === 'FileSubmissionAssignment') {

          this.showUploader(event);

        } else if (type === 'ExternalAssignment') {

          this.openExternalApplication();

        }
      }
    },

    submitCourseworkEntry(data, container) {
      let self = this;
      let submitted = self.coursework.group.enabled ? self.coursework.group.self_submitted : self.coursework.is_submitted;
      let url = Kadenze.Routes.course_coursework_coursework_entries_path(this.coursework.course_id, self.coursework.id);
      let method = 'POST';
      if (submitted && self.coursework_entry.id) {
        url = Kadenze.Routes.course_coursework_coursework_entry_path(this.coursework.course_id, self.coursework.id, this.coursework_entry.id);
        method = 'PATCH';
      }

      let response = new Kadenze.AjaxRequest({
        type: method,
        data: data,
        url: url,
        loadingIndicator: {container: container, positionTop: 'absolute', message: 'Submitting...'}
      });

      response.done(function (_response, _status, xhr) {
        let was_first_adaptive_submission = self.coursework.is_first_adaptive_submission;
        self.$parent.getCoursework().done(function(_data, _textStatus, _xhr) {
          if(was_first_adaptive_submission && !self.$parent.user_preferences['hide_due_dates']) {
            Kadenze.UIUtil.showFirstSubmissionModal(self.$parent.user_preferences, self.$el);
          }
        });
        new Kadenze.Notice.success(xhr.responseJSON);
      });

      response.fail(function(xhr, _status, _msg) {
        new Kadenze.Notice.error(xhr.responseJSON);
      });
    }
  },
  created() {
    this.$parent.steps.push(this);
  },
  mounted() {
    this.initProctorModal();
  }
};
